/* =========================================================================
   Personalization swatches — Worldwatch.market
   - Reveals "Foil color" group only when "Foil" technique is chosen
   - Live character counter per row
   - Validates: max 10 chars/row, each character max 2× per row, row 2 only
     allowed if row 1 filled
   - Blocks the product form's submit button while invalid
   ========================================================================= */
(function () {
  'use strict';

  const root = document.querySelector('[data-perso-root]');
  if (!root) return;

  // ----- Config from data-attrs -----
  const MAX_ROWS            = parseInt(root.dataset.maxRows || '2', 10);
  const MAX_CHARS_PER_ROW   = parseInt(root.dataset.maxCharsPerRow || '10', 10);
  const MAX_REPEATS_PER_ROW = parseInt(root.dataset.maxRepeatsPerRow || '2', 10);

  // ----- Elements -----
  const techniqueInputs = root.querySelectorAll('input[name="properties[Technique]"]');
  const foilGroup       = root.querySelector('[data-foil-color]');
  const foilInputs      = root.querySelectorAll('[data-foil-required]');
  const textInputs      = root.querySelectorAll('.wwm-perso__input');
  const errorEl         = root.querySelector('[data-perso-error]');

  const productForm =
    root.closest('form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');

  // ----- Personalisation toggle integration -----
  function isPersoActive() {
    const no = document.getElementById('personalisation-no');
    return no ? !no.checked : true;
  }

  // ----- Foil color reveal -----
  function syncFoilVisibility() {
    const selected = root.querySelector('input[name="properties[Technique]"]:checked');
    const isFoil = selected && selected.value === 'Foil';

    if (isFoil) {
      foilGroup.hidden = false;
    } else {
      foilGroup.hidden = true;
      foilInputs.forEach((i) => { i.checked = false; });
    }
  }

  techniqueInputs.forEach((input) => {
    input.addEventListener('change', () => {
      syncFoilVisibility();
      validate();
    });
  });

  foilInputs.forEach((input) => {
    input.addEventListener('change', validate);
  });

  // ----- Counters -----
  function updateCounter(input) {
    const row = input.dataset.persoRow;
    const counter = root.querySelector('#wwm-perso-counter-' + row);
    if (counter) {
      counter.textContent = input.value.length + ' / ' + MAX_CHARS_PER_ROW;
    }
  }

  // ----- Validation -----
  function checkRow(value) {
    if (value.length > MAX_CHARS_PER_ROW) {
      return 'Each row is max ' + MAX_CHARS_PER_ROW + ' characters.';
    }
    const counts = {};
    for (const ch of value.toLowerCase()) {
      counts[ch] = (counts[ch] || 0) + 1;
      if (counts[ch] > MAX_REPEATS_PER_ROW) {
        const display = ch === ' ' ? 'space' : '"' + ch + '"';
        return 'Each character can only be used ' + MAX_REPEATS_PER_ROW +
               ' times per row (' + display + ' used ' + counts[ch] + '×).';
      }
    }
    return null;
  }

  function validate() {
    if (!isPersoActive()) {
      errorEl.hidden = true;
      errorEl.textContent = '';
      setSubmitDisabled(false);
      return true;
    }

    let firstError = null;
    const inputs = Array.from(textInputs);

    inputs.forEach((input) => input.classList.remove('is-invalid'));

    const row1 = inputs[0];
    const row2 = inputs[1];

    if (row2 && row2.value.trim() && row1 && !row1.value.trim()) {
      firstError = 'Please fill the first row before using the second.';
      row2.classList.add('is-invalid');
    }

    if (!firstError) {
      for (const input of inputs) {
        const err = checkRow(input.value);
        if (err) {
          firstError = err;
          input.classList.add('is-invalid');
          break;
        }
      }
    }

    if (!firstError) {
      const technique = root.querySelector('input[name="properties[Technique]"]:checked');
      if (technique && technique.value === 'Foil') {
        const colorPicked = root.querySelector('[data-foil-required]:checked');
        if (!colorPicked) {
          firstError = 'Please choose a foil color (silver or gold).';
        }
      }
    }

    if (firstError) {
      errorEl.textContent = firstError;
      errorEl.hidden = false;
      setSubmitDisabled(true);
      return false;
    }

    errorEl.hidden = true;
    errorEl.textContent = '';
    setSubmitDisabled(false);
    return true;
  }

  function setSubmitDisabled(disabled) {
    if (!productForm) return;
    const buttons = productForm.querySelectorAll(
      'button[type="submit"], button[name="add"], [data-add-to-cart]'
    );
    buttons.forEach((btn) => {
      btn.disabled = disabled;
      btn.toggleAttribute('aria-disabled', disabled);
    });
  }

  // ----- Wire up text inputs -----
  textInputs.forEach((input) => {
    input.addEventListener('input', () => {
      updateCounter(input);
      validate();
    });
    updateCounter(input);
  });

  // Block form submission as safety net
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      if (!validate()) {
        e.preventDefault();
        e.stopPropagation();
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }

  // ----- Personalisation Yes/No toggle -----
  const persoNo    = document.getElementById('personalisation-no');
  const persoYes   = document.getElementById('personalisation-yes');
  const persoFields = document.getElementById('personalisation-fields');

  if (persoNo) {
    persoNo.addEventListener('change', function () {
      if (persoFields) persoFields.style.display = 'none';
      validate();
    });
  }
  if (persoYes) {
    persoYes.addEventListener('change', function () {
      if (persoFields) persoFields.style.display = 'block';
      validate();
    });
  }

  // Hide fields on load if No is checked
  if (persoNo && persoNo.checked && persoFields) {
    persoFields.style.display = 'none';
  }

  // ----- Initial state -----
  syncFoilVisibility();
  validate();
})();